import React from 'react';
import styled from '@emotion/styled';
import { theme } from '../../styles/theme';

const StyledCard = styled.div`
  background: ${theme.colors.surface};
  border-radius: ${props => theme.borderRadius[props.radius || 'md']};
  box-shadow: ${props => theme.shadows[props.elevation || 'sm']};
  overflow: hidden;
  transition: all 0.2s ease-in-out;
  
  ${props => props.hoverable && `
    &:hover {
      transform: translateY(-4px);
      box-shadow: ${theme.shadows.lg};
    }
  `}
`;

const CardHeader = styled.div`
  padding: ${theme.spacing.md};
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  
  h1, h2, h3, h4, h5, h6 {
    margin: 0;
  }
`;

const CardContent = styled.div`
  padding: ${theme.spacing.md};
`;

const CardFooter = styled.div`
  padding: ${theme.spacing.md};
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  display: flex;
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
`;

const Card = ({
  children,
  header,
  footer,
  radius = 'md',
  elevation = 'sm',
  hoverable = false,
  className,
  ...props
}) => {
  return (
    <StyledCard
      radius={radius}
      elevation={elevation}
      hoverable={hoverable}
      className={className}
      {...props}
    >
      {header && <CardHeader>{header}</CardHeader>}
      <CardContent>{children}</CardContent>
      {footer && <CardFooter>{footer}</CardFooter>}
    </StyledCard>
  );
};

export default Card; 